import * as F from "../../../victory-vendor/es/d3-scale.js";
import E from "../../../../_virtual/max.js";
import I from "../../../../_virtual/min.js";
import S from "../../../../_virtual/isNil.js";
import G from "../../../../_virtual/isFunction.js";
import j from "../../../../_virtual/isString.js";
import Z from "../../../../_virtual/get.js";
import _ from "../../../../_virtual/flatMap.js";
import W from "../../../../_virtual/isNaN.js";
import rr from "../../../../_virtual/upperFirst.js";
import tr from "../../../../_virtual/isEqual.js";
import er from "../../../../_virtual/sortBy.js";
import { getNiceTickValues as nr, getTickValuesFixedDomain as ar } from "../../../recharts-scale/es6/getNiceTickValues.js";
import { ErrorBar as ir } from "../cartesian/ErrorBar.js";
import { mathSign as w, isNumOrStr as L, uniqueId as or, isNumber as A, getPercentValue as N, findEntryInArray as ur } from "./DataUtils.js";
import { getDisplayName as fr, filterProps as cr, findAllByType as sr } from "./ReactUtils.js";
import { getLegendProps as lr } from "./getLegendProps.js";
import $, { point as K } from "../../../d3-scale/src/band.js";
import R from "../../../d3-scale/src/linear.js";
import vr from "../../../d3-shape/src/stack.js";
import pr from "../../../d3-shape/src/order/none.js";
import dr from "../../../d3-shape/src/offset/wiggle.js";
import mr from "../../../d3-shape/src/offset/silhouette.js";
import yr from "../../../d3-shape/src/offset/none.js";
import gr from "../../../d3-shape/src/offset/expand.js";
function C(i) {
  "@babel/helpers - typeof";
  return C = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, C(i);
}
function U(i) {
  return br(i) || Or(i) || kr(i) || hr();
}
function hr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kr(i, r) {
  if (i) {
    if (typeof i == "string") return V(i, r);
    var t = Object.prototype.toString.call(i).slice(8, -1);
    if (t === "Object" && i.constructor && (t = i.constructor.name), t === "Map" || t === "Set") return Array.from(i);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return V(i, r);
  }
}
function Or(i) {
  if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
}
function br(i) {
  if (Array.isArray(i)) return V(i);
}
function V(i, r) {
  (r == null || r > i.length) && (r = i.length);
  for (var t = 0, e = new Array(r); t < r; t++) e[t] = i[t];
  return e;
}
function q(i, r) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(i);
    r && (e = e.filter(function(n) {
      return Object.getOwnPropertyDescriptor(i, n).enumerable;
    })), t.push.apply(t, e);
  }
  return t;
}
function g(i) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? q(Object(t), !0).forEach(function(e) {
      T(i, e, t[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : q(Object(t)).forEach(function(e) {
      Object.defineProperty(i, e, Object.getOwnPropertyDescriptor(t, e));
    });
  }
  return i;
}
function T(i, r, t) {
  return r = Sr(r), r in i ? Object.defineProperty(i, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = t, i;
}
function Sr(i) {
  var r = xr(i, "string");
  return C(r) == "symbol" ? r : r + "";
}
function xr(i, r) {
  if (C(i) != "object" || !i) return i;
  var t = i[Symbol.toPrimitive];
  if (t !== void 0) {
    var e = t.call(i, r);
    if (C(e) != "object") return e;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(i);
}
function P(i, r, t) {
  return S(i) || S(r) ? t : L(r) ? Z(i, r, t) : G(r) ? r(i) : t;
}
function X(i, r, t, e) {
  var n = _(i, function(a) {
    return P(a, r);
  });
  if (t === "number") {
    var o = n.filter(function(a) {
      return A(a) || parseFloat(a);
    });
    return o.length ? [I(o), E(o)] : [1 / 0, -1 / 0];
  }
  var u = e ? n.filter(function(a) {
    return !S(a);
  }) : n;
  return u.map(function(a) {
    return L(a) || a instanceof Date ? a : "";
  });
}
var tt = function(r) {
  var t, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 ? arguments[2] : void 0, o = arguments.length > 3 ? arguments[3] : void 0, u = -1, a = (t = e == null ? void 0 : e.length) !== null && t !== void 0 ? t : 0;
  if (a <= 1)
    return 0;
  if (o && o.axisType === "angleAxis" && Math.abs(Math.abs(o.range[1] - o.range[0]) - 360) <= 1e-6)
    for (var f = o.range, c = 0; c < a; c++) {
      var l = c > 0 ? n[c - 1].coordinate : n[a - 1].coordinate, s = n[c].coordinate, v = c >= a - 1 ? n[0].coordinate : n[c + 1].coordinate, d = void 0;
      if (w(s - l) !== w(v - s)) {
        var p = [];
        if (w(v - s) === w(f[1] - f[0])) {
          d = v;
          var h = s + f[1] - f[0];
          p[0] = Math.min(h, (h + l) / 2), p[1] = Math.max(h, (h + l) / 2);
        } else {
          d = l;
          var k = v + f[1] - f[0];
          p[0] = Math.min(s, (k + s) / 2), p[1] = Math.max(s, (k + s) / 2);
        }
        var y = [Math.min(s, (d + s) / 2), Math.max(s, (d + s) / 2)];
        if (r > y[0] && r <= y[1] || r >= p[0] && r <= p[1]) {
          u = n[c].index;
          break;
        }
      } else {
        var O = Math.min(l, v), M = Math.max(l, v);
        if (r > (O + s) / 2 && r <= (M + s) / 2) {
          u = n[c].index;
          break;
        }
      }
    }
  else
    for (var m = 0; m < a; m++)
      if (m === 0 && r <= (e[m].coordinate + e[m + 1].coordinate) / 2 || m > 0 && m < a - 1 && r > (e[m].coordinate + e[m - 1].coordinate) / 2 && r <= (e[m].coordinate + e[m + 1].coordinate) / 2 || m === a - 1 && r > (e[m].coordinate + e[m - 1].coordinate) / 2) {
        u = e[m].index;
        break;
      }
  return u;
}, Ar = function(r) {
  var t, e = r, n = e.type.displayName, o = (t = r.type) !== null && t !== void 0 && t.defaultProps ? g(g({}, r.type.defaultProps), r.props) : r.props, u = o.stroke, a = o.fill, f;
  switch (n) {
    case "Line":
      f = u;
      break;
    case "Area":
    case "Radar":
      f = u && u !== "none" ? u : a;
      break;
    default:
      f = a;
      break;
  }
  return f;
}, et = function(r) {
  var t = r.barSize, e = r.totalSize, n = r.stackGroups, o = n === void 0 ? {} : n;
  if (!o)
    return {};
  for (var u = {}, a = Object.keys(o), f = 0, c = a.length; f < c; f++)
    for (var l = o[a[f]].stackGroups, s = Object.keys(l), v = 0, d = s.length; v < d; v++) {
      var p = l[s[v]], h = p.items, k = p.cateAxisId, y = h.filter(function(x) {
        return fr(x.type).indexOf("Bar") >= 0;
      });
      if (y && y.length) {
        var O = y[0].type.defaultProps, M = O !== void 0 ? g(g({}, O), y[0].props) : y[0].props, m = M.barSize, b = M[k];
        u[b] || (u[b] = []);
        var B = S(m) ? t : m;
        u[b].push({
          item: y[0],
          stackList: y.slice(1),
          barSize: S(B) ? void 0 : N(B, e, 0)
        });
      }
    }
  return u;
}, nt = function(r) {
  var t = r.barGap, e = r.barCategoryGap, n = r.bandSize, o = r.sizeList, u = o === void 0 ? [] : o, a = r.maxBarSize, f = u.length;
  if (f < 1) return null;
  var c = N(t, n, 0, !0), l, s = [];
  if (u[0].barSize === +u[0].barSize) {
    var v = !1, d = n / f, p = u.reduce(function(m, b) {
      return m + b.barSize || 0;
    }, 0);
    p += (f - 1) * c, p >= n && (p -= (f - 1) * c, c = 0), p >= n && d > 0 && (v = !0, d *= 0.9, p = f * d);
    var h = (n - p) / 2 >> 0, k = {
      offset: h - c,
      size: 0
    };
    l = u.reduce(function(m, b) {
      var B = {
        item: b.item,
        position: {
          offset: k.offset + k.size + c,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: v ? d : b.barSize
        }
      }, x = [].concat(U(m), [B]);
      return k = x[x.length - 1].position, b.stackList && b.stackList.length && b.stackList.forEach(function(z) {
        x.push({
          item: z,
          position: k
        });
      }), x;
    }, s);
  } else {
    var y = N(e, n, 0, !0);
    n - 2 * y - (f - 1) * c <= 0 && (c = 0);
    var O = (n - 2 * y - (f - 1) * c) / f;
    O > 1 && (O >>= 0);
    var M = a === +a ? Math.min(O, a) : O;
    l = u.reduce(function(m, b, B) {
      var x = [].concat(U(m), [{
        item: b.item,
        position: {
          offset: y + (O + c) * B + (O - M) / 2,
          size: M
        }
      }]);
      return b.stackList && b.stackList.length && b.stackList.forEach(function(z) {
        x.push({
          item: z,
          position: x[x.length - 1].position
        });
      }), x;
    }, s);
  }
  return l;
}, at = function(r, t, e, n) {
  var o = e.children, u = e.width, a = e.margin, f = u - (a.left || 0) - (a.right || 0), c = lr({
    children: o,
    legendWidth: f
  });
  if (c) {
    var l = n || {}, s = l.width, v = l.height, d = c.align, p = c.verticalAlign, h = c.layout;
    if ((h === "vertical" || h === "horizontal" && p === "middle") && d !== "center" && A(r[d]))
      return g(g({}, r), {}, T({}, d, r[d] + (s || 0)));
    if ((h === "horizontal" || h === "vertical" && d === "center") && p !== "middle" && A(r[p]))
      return g(g({}, r), {}, T({}, p, r[p] + (v || 0)));
  }
  return r;
}, Mr = function(r, t, e) {
  return S(t) ? !0 : r === "horizontal" ? t === "yAxis" : r === "vertical" || e === "x" ? t === "xAxis" : e === "y" ? t === "yAxis" : !0;
}, H = function(r, t, e, n, o) {
  var u = t.props.children, a = sr(u, ir).filter(function(c) {
    return Mr(n, o, c.props.direction);
  });
  if (a && a.length) {
    var f = a.map(function(c) {
      return c.props.dataKey;
    });
    return r.reduce(function(c, l) {
      var s = P(l, e);
      if (S(s)) return c;
      var v = Array.isArray(s) ? [I(s), E(s)] : [s, s], d = f.reduce(function(p, h) {
        var k = P(l, h, 0), y = v[0] - Math.abs(Array.isArray(k) ? k[0] : k), O = v[1] + Math.abs(Array.isArray(k) ? k[1] : k);
        return [Math.min(y, p[0]), Math.max(O, p[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(d[0], c[0]), Math.max(d[1], c[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, it = function(r, t, e, n, o) {
  var u = t.map(function(a) {
    return H(r, a, e, o, n);
  }).filter(function(a) {
    return !S(a);
  });
  return u && u.length ? u.reduce(function(a, f) {
    return [Math.min(a[0], f[0]), Math.max(a[1], f[1])];
  }, [1 / 0, -1 / 0]) : null;
}, ot = function(r, t, e, n, o) {
  var u = t.map(function(f) {
    var c = f.props.dataKey;
    return e === "number" && c && H(r, f, c, n) || X(r, c, e, o);
  });
  if (e === "number")
    return u.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(f, c) {
        return [Math.min(f[0], c[0]), Math.max(f[1], c[1])];
      },
      [1 / 0, -1 / 0]
    );
  var a = {};
  return u.reduce(function(f, c) {
    for (var l = 0, s = c.length; l < s; l++)
      a[c[l]] || (a[c[l]] = !0, f.push(c[l]));
    return f;
  }, []);
}, ut = function(r, t) {
  return r === "horizontal" && t === "xAxis" || r === "vertical" && t === "yAxis" || r === "centric" && t === "angleAxis" || r === "radial" && t === "radiusAxis";
}, ft = function(r, t, e, n) {
  if (n)
    return r.map(function(f) {
      return f.coordinate;
    });
  var o, u, a = r.map(function(f) {
    return f.coordinate === t && (o = !0), f.coordinate === e && (u = !0), f.coordinate;
  });
  return o || a.push(t), u || a.push(e), a;
}, ct = function(r, t, e) {
  if (!r) return null;
  var n = r.scale, o = r.duplicateDomain, u = r.type, a = r.range, f = r.realScaleType === "scaleBand" ? n.bandwidth() / 2 : 2, c = (t || e) && u === "category" && n.bandwidth ? n.bandwidth() / f : 0;
  if (c = r.axisType === "angleAxis" && (a == null ? void 0 : a.length) >= 2 ? w(a[0] - a[1]) * 2 * c : c, t && (r.ticks || r.niceTicks)) {
    var l = (r.ticks || r.niceTicks).map(function(s) {
      var v = o ? o.indexOf(s) : s;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: n(v) + c,
        value: s,
        offset: c
      };
    });
    return l.filter(function(s) {
      return !W(s.coordinate);
    });
  }
  return r.isCategorical && r.categoricalDomain ? r.categoricalDomain.map(function(s, v) {
    return {
      coordinate: n(s) + c,
      value: s,
      index: v,
      offset: c
    };
  }) : n.ticks && !e ? n.ticks(r.tickCount).map(function(s) {
    return {
      coordinate: n(s) + c,
      value: s,
      offset: c
    };
  }) : n.domain().map(function(s, v) {
    return {
      coordinate: n(s) + c,
      value: o ? o[s] : s,
      index: v,
      offset: c
    };
  });
}, D = /* @__PURE__ */ new WeakMap(), st = function(r, t) {
  if (typeof t != "function")
    return r;
  D.has(r) || D.set(r, /* @__PURE__ */ new WeakMap());
  var e = D.get(r);
  if (e.has(t))
    return e.get(t);
  var n = function() {
    r.apply(void 0, arguments), t.apply(void 0, arguments);
  };
  return e.set(t, n), n;
}, lt = function(r, t, e) {
  var n = r.scale, o = r.type, u = r.layout, a = r.axisType;
  if (n === "auto")
    return u === "radial" && a === "radiusAxis" ? {
      scale: $(),
      realScaleType: "band"
    } : u === "radial" && a === "angleAxis" ? {
      scale: R(),
      realScaleType: "linear"
    } : o === "category" && t && (t.indexOf("LineChart") >= 0 || t.indexOf("AreaChart") >= 0 || t.indexOf("ComposedChart") >= 0 && !e) ? {
      scale: K(),
      realScaleType: "point"
    } : o === "category" ? {
      scale: $(),
      realScaleType: "band"
    } : {
      scale: R(),
      realScaleType: "linear"
    };
  if (j(n)) {
    var f = "scale".concat(rr(n));
    return {
      scale: (F[f] || K)(),
      realScaleType: F[f] ? f : "point"
    };
  }
  return G(n) ? {
    scale: n
  } : {
    scale: K(),
    realScaleType: "point"
  };
}, J = 1e-4, vt = function(r) {
  var t = r.domain();
  if (!(!t || t.length <= 2)) {
    var e = t.length, n = r.range(), o = Math.min(n[0], n[1]) - J, u = Math.max(n[0], n[1]) + J, a = r(t[0]), f = r(t[e - 1]);
    (a < o || a > u || f < o || f > u) && r.domain([t[0], t[e - 1]]);
  }
}, pt = function(r, t) {
  if (!r)
    return null;
  for (var e = 0, n = r.length; e < n; e++)
    if (r[e].item === t)
      return r[e].position;
  return null;
}, dt = function(r, t) {
  if (!t || t.length !== 2 || !A(t[0]) || !A(t[1]))
    return r;
  var e = Math.min(t[0], t[1]), n = Math.max(t[0], t[1]), o = [r[0], r[1]];
  return (!A(r[0]) || r[0] < e) && (o[0] = e), (!A(r[1]) || r[1] > n) && (o[1] = n), o[0] > n && (o[0] = n), o[1] < e && (o[1] = e), o;
}, Pr = function(r) {
  var t = r.length;
  if (!(t <= 0))
    for (var e = 0, n = r[0].length; e < n; ++e)
      for (var o = 0, u = 0, a = 0; a < t; ++a) {
        var f = W(r[a][e][1]) ? r[a][e][0] : r[a][e][1];
        f >= 0 ? (r[a][e][0] = o, r[a][e][1] = o + f, o = r[a][e][1]) : (r[a][e][0] = u, r[a][e][1] = u + f, u = r[a][e][1]);
      }
}, Br = function(r) {
  var t = r.length;
  if (!(t <= 0))
    for (var e = 0, n = r[0].length; e < n; ++e)
      for (var o = 0, u = 0; u < t; ++u) {
        var a = W(r[u][e][1]) ? r[u][e][0] : r[u][e][1];
        a >= 0 ? (r[u][e][0] = o, r[u][e][1] = o + a, o = r[u][e][1]) : (r[u][e][0] = 0, r[u][e][1] = 0);
      }
}, Tr = {
  sign: Pr,
  // @ts-expect-error definitelytyped types are incorrect
  expand: gr,
  // @ts-expect-error definitelytyped types are incorrect
  none: yr,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: mr,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: dr,
  positive: Br
}, wr = function(r, t, e) {
  var n = t.map(function(a) {
    return a.props.dataKey;
  }), o = Tr[e], u = vr().keys(n).value(function(a, f) {
    return +P(a, f, 0);
  }).order(pr).offset(o);
  return u(r);
}, mt = function(r, t, e, n, o, u) {
  if (!r)
    return null;
  var a = u ? t.reverse() : t, f = {}, c = a.reduce(function(s, v) {
    var d, p = (d = v.type) !== null && d !== void 0 && d.defaultProps ? g(g({}, v.type.defaultProps), v.props) : v.props, h = p.stackId, k = p.hide;
    if (k)
      return s;
    var y = p[e], O = s[y] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (L(h)) {
      var M = O.stackGroups[h] || {
        numericAxisId: e,
        cateAxisId: n,
        items: []
      };
      M.items.push(v), O.hasStack = !0, O.stackGroups[h] = M;
    } else
      O.stackGroups[or("_stackId_")] = {
        numericAxisId: e,
        cateAxisId: n,
        items: [v]
      };
    return g(g({}, s), {}, T({}, y, O));
  }, f), l = {};
  return Object.keys(c).reduce(function(s, v) {
    var d = c[v];
    if (d.hasStack) {
      var p = {};
      d.stackGroups = Object.keys(d.stackGroups).reduce(function(h, k) {
        var y = d.stackGroups[k];
        return g(g({}, h), {}, T({}, k, {
          numericAxisId: e,
          cateAxisId: n,
          items: y.items,
          stackedData: wr(r, y.items, o)
        }));
      }, p);
    }
    return g(g({}, s), {}, T({}, v, d));
  }, l);
}, yt = function(r, t) {
  var e = t.realScaleType, n = t.type, o = t.tickCount, u = t.originalDomain, a = t.allowDecimals, f = e || t.scale;
  if (f !== "auto" && f !== "linear")
    return null;
  if (o && n === "number" && u && (u[0] === "auto" || u[1] === "auto")) {
    var c = r.domain();
    if (!c.length)
      return null;
    var l = nr(c, o, a);
    return r.domain([I(l), E(l)]), {
      niceTicks: l
    };
  }
  if (o && n === "number") {
    var s = r.domain(), v = ar(s, o, a);
    return {
      niceTicks: v
    };
  }
  return null;
};
function gt(i) {
  var r = i.axis, t = i.ticks, e = i.bandSize, n = i.entry, o = i.index, u = i.dataKey;
  if (r.type === "category") {
    if (!r.allowDuplicatedCategory && r.dataKey && !S(n[r.dataKey])) {
      var a = ur(t, "value", n[r.dataKey]);
      if (a)
        return a.coordinate + e / 2;
    }
    return t[o] ? t[o].coordinate + e / 2 : null;
  }
  var f = P(n, S(u) ? r.dataKey : u);
  return S(f) ? null : r.scale(f);
}
var ht = function(r) {
  var t = r.axis, e = r.ticks, n = r.offset, o = r.bandSize, u = r.entry, a = r.index;
  if (t.type === "category")
    return e[a] ? e[a].coordinate + n : null;
  var f = P(u, t.dataKey, t.domain[a]);
  return S(f) ? null : t.scale(f) - o / 2 + n;
}, kt = function(r) {
  var t = r.numericAxis, e = t.scale.domain();
  if (t.type === "number") {
    var n = Math.min(e[0], e[1]), o = Math.max(e[0], e[1]);
    return n <= 0 && o >= 0 ? 0 : o < 0 ? o : n;
  }
  return e[0];
}, Ot = function(r, t) {
  var e, n = (e = r.type) !== null && e !== void 0 && e.defaultProps ? g(g({}, r.type.defaultProps), r.props) : r.props, o = n.stackId;
  if (L(o)) {
    var u = t[o];
    if (u) {
      var a = u.items.indexOf(r);
      return a >= 0 ? u.stackedData[a] : null;
    }
  }
  return null;
}, Gr = function(r) {
  return r.reduce(function(t, e) {
    return [I(e.concat([t[0]]).filter(A)), E(e.concat([t[1]]).filter(A))];
  }, [1 / 0, -1 / 0]);
}, bt = function(r, t, e) {
  return Object.keys(r).reduce(function(n, o) {
    var u = r[o], a = u.stackedData, f = a.reduce(function(c, l) {
      var s = Gr(l.slice(t, e + 1));
      return [Math.min(c[0], s[0]), Math.max(c[1], s[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(f[0], n[0]), Math.max(f[1], n[1])];
  }, [1 / 0, -1 / 0]).map(function(n) {
    return n === 1 / 0 || n === -1 / 0 ? 0 : n;
  });
}, Q = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, Y = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, St = function(r, t, e) {
  if (G(r))
    return r(t, e);
  if (!Array.isArray(r))
    return t;
  var n = [];
  if (A(r[0]))
    n[0] = e ? r[0] : Math.min(r[0], t[0]);
  else if (Q.test(r[0])) {
    var o = +Q.exec(r[0])[1];
    n[0] = t[0] - o;
  } else G(r[0]) ? n[0] = r[0](t[0]) : n[0] = t[0];
  if (A(r[1]))
    n[1] = e ? r[1] : Math.max(r[1], t[1]);
  else if (Y.test(r[1])) {
    var u = +Y.exec(r[1])[1];
    n[1] = t[1] + u;
  } else G(r[1]) ? n[1] = r[1](t[1]) : n[1] = t[1];
  return n;
}, xt = function(r, t, e) {
  if (r && r.scale && r.scale.bandwidth) {
    var n = r.scale.bandwidth();
    if (!e || n > 0)
      return n;
  }
  if (r && t && t.length >= 2) {
    for (var o = er(t, function(s) {
      return s.coordinate;
    }), u = 1 / 0, a = 1, f = o.length; a < f; a++) {
      var c = o[a], l = o[a - 1];
      u = Math.min((c.coordinate || 0) - (l.coordinate || 0), u);
    }
    return u === 1 / 0 ? 0 : u;
  }
  return e ? void 0 : 0;
}, At = function(r, t, e) {
  return !r || !r.length || tr(r, Z(e, "type.defaultProps.domain")) ? t : r;
}, Mt = function(r, t) {
  var e = r.type.defaultProps ? g(g({}, r.type.defaultProps), r.props) : r.props, n = e.dataKey, o = e.name, u = e.unit, a = e.formatter, f = e.tooltipType, c = e.chartType, l = e.hide;
  return g(g({}, cr(r, !1)), {}, {
    dataKey: n,
    unit: u,
    formatter: a,
    name: o || n,
    color: Ar(r),
    value: P(t, n),
    type: f,
    payload: t,
    chartType: c,
    hide: l
  });
};
export {
  Y as MAX_VALUE_REG,
  Q as MIN_VALUE_REG,
  at as appendOffsetOfLegend,
  tt as calculateActiveTickIndex,
  vt as checkDomainOfScale,
  st as combineEventHandlers,
  pt as findPositionOfBar,
  xt as getBandSizeOfAxis,
  nt as getBarPosition,
  et as getBarSizeList,
  kt as getBaseValueOfBar,
  ht as getCateCoordinateOfBar,
  gt as getCateCoordinateOfLine,
  ft as getCoordinatesOfGrid,
  X as getDomainOfDataByKey,
  H as getDomainOfErrorBars,
  ot as getDomainOfItemsWithSameAxis,
  bt as getDomainOfStackGroups,
  lr as getLegendProps,
  Ar as getMainColorOfGraphicItem,
  mt as getStackGroupsByAxisId,
  wr as getStackedData,
  Ot as getStackedDataOfItem,
  ct as getTicksOfAxis,
  yt as getTicksOfScale,
  Mt as getTooltipItem,
  P as getValueByDataKey,
  ut as isCategoricalAxis,
  Br as offsetPositive,
  Pr as offsetSign,
  At as parseDomainOfCategoryAxis,
  it as parseErrorBarsOfAxis,
  lt as parseScale,
  St as parseSpecifiedDomain,
  dt as truncateByDomain
};
